function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
//Limitless imports
import SystemDialogue from "../system-dialogue/SystemDialogue";
import { log as pilog } from "@limitless/common/utils/Logging";
const SystemExpiryDialogue = ({
  classes,
  theme,
  ...rest
}) => {
  let Icon = /*#__PURE__*/React.createElement(InfoOutlined, {
    className: classes.primaryText
  });
  try {
    if (theme.palette.dialogues) {
      if (theme.palette.dialogues.expiry.iconUrl) {
        Icon = /*#__PURE__*/React.createElement("img", {
          src: theme.palette.dialogues.expiry.iconUrl
        });
      }
      if (theme.palette.dialogues.expiry.bodyClass) {
        classes.infoDialogueBody = theme.palette.dialogues.expiry.bodyClass;
      }
      if (theme.palette.dialogues.expiry.containerClass) {
        classes.infoDialogueContainer = theme.palette.dialogues.expiry.containerClass;
      }
    }
  } catch (error) {
    var _rest$dialogue;
    const log = pilog.getLogger("SystemExpiryDialogue");
    log.warn(`Invalid theme object for ${(_rest$dialogue = rest.dialogue) === null || _rest$dialogue === void 0 ? void 0 : _rest$dialogue.groupName}`);
  }
  return /*#__PURE__*/React.createElement(SystemDialogue, _extends({
    body: rest.dialogue.body,
    dialogueClasses: classes,
    Icon: Icon
  }, rest));
};
const styles = ({
  palette
}) => {
  const expiryStyles = {
    primaryBackground: {
      backgroundColor: palette.contrast.main
    },
    primaryText: {
      color: palette.contrast.light
    }
  };
  try {
    expiryStyles.primaryBackground.backgroundColor = palette.dialogues.expiry.background;
    if (palette.dialogues.expiry.color) {
      expiryStyles.primaryText.color = palette.dialogues.expiry.color;
    }
    if (palette.dialogues.expiry.fontFamily) {
      var _palette$dialogues, _palette$dialogues$ex;
      expiryStyles.primaryText.fontFamily = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$ex = _palette$dialogues.expiry) === null || _palette$dialogues$ex === void 0 ? void 0 : _palette$dialogues$ex.fontFamily;
    }
  } catch (error) {
    const log = pilog.getLogger("SystemExpiryDialogue");
    log.info("Invalid theme object SystemExpiryDialogue");
  }
  return expiryStyles;
};
export default withStyles(styles, {
  withTheme: true
})(SystemExpiryDialogue);
SystemExpiryDialogue.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};